import React,  {useContext} from "react";
import "./LavaroPopup.scss";
import { ReactComponent as LavoroAiIcon } from "../assets/images/nav-icons/lavoro-bowl.svg";
import { ReactComponent as AIAssistant }from "../assets/images/nav-icons/aiassistant.svg";
import { ReactComponent as TimeArrowNew } from "../assets/images/nav-icons/timearrow-icon.svg";
import { ReactComponent as TimeArrowNewDark } from "../assets/images/nav-icons/timearrowDark.svg";
import { ReactComponent as StarIcon } from "../assets/images/nav-icons/star.svg";
import AppContext from "../config/AppContext";
import { useTranslation } from "react-i18next";

const LavaroPopup = ({activeStarIndex = 3,setPredictionCount, setShowSelectionAnimation}) => {
         const { mode } = useContext(AppContext);
          const { t } = useTranslation();
    const totalStars = 10;

    const handleLogEntryClick = () => {
        setShowSelectionAnimation(true); 
        setPredictionCount(-1);
      };

    return (
        <div className="backdrop">
            <div className={mode === "dark"? "BootcamPopupDark": "BootcamPopup"}>
                <div className="bootcamp">
                    <AIAssistant />
                    <span className={mode === "dark" ? "bootcamptitleDark": "bootcamptitle"}>AI{t("RAL0981")}</span>
                </div>
                <div className="star-container">
                    {Array.from({ length: totalStars }).map((_, index) => {
                        const starIndex = index + 1; 
                        return (
                            <div
                                key={starIndex}
                                className={`star ${starIndex === activeStarIndex ? "expand-star" : ""} ${starIndex > activeStarIndex ? "faded-star" : ""}`}
                            >
                                <StarIcon />
                            </div>
                        );
                    })}
                </div>

                <div className={mode === "dark"? "niceletsDark":"nicelets"}>
                    <span>
                        {activeStarIndex}{t("RAL0982")}
                    </span>
                </div>
                    <div className="timesheettbutton">
                        <button className={mode === "dark"? "timecancelDark":"timecancel"}  onClick={()=>setPredictionCount(-1)}>{t("RAL0177")}</button>
                        <button className={mode === "dark"? "nowlogentryDark": "nowlogentry"}  onClick={handleLogEntryClick}>
                        {t("RAL0983")}  {mode === "dark" ? <TimeArrowNewDark /> : <TimeArrowNew />}
                        </button>
                    </div>
                </div>
            </div>
    );
};

export default LavaroPopup;
